export default __webpack_public_path__ + "2fb0d14e065d80b59b40e146cd4d8cd9.png";